import React from "react"
import Clients from "./pages/Clients/Clients"
import Abonements from "./pages/Abonements/Abonements"
import Trainers from "./pages/Administrator/Trainers/Trainers"
import Clubs from "./pages/Administrator/Clubs/Clubs"
import ClubTypes from "./pages/Administrator/ClubTypes/ClubTypes"
import Payments from "./pages/Administrator/Payments/Payments"
import Booking from "./pages/Administrator/Booking/Booking"
import Stocks from "./pages/Administrator/Stocks/Stocks"
import Services from "./pages/Administrator/Services/Services"
import Slots from "./pages/Administrator/Slots/Slots"
import Schedule from "./pages/Administrator/Schedule/Schedule"
import Gyms from "./pages/Administrator/Gyms/Gyms"
import Lockers from "./pages/Administrator/Lockers/Lockers"
import PacketsTrainings from "./pages/Administrator/PacketsTrainings/PacketsTrainings"
import Trainings from "./pages/Administrator/Trainings/Trainings"
import Galery from "./pages/Administrator/Galery/Galery"
import Users from "./pages/Accounts/Users/Users"
import Roles from "./pages/Accounts/Roles/Roles"
import ClientsNew from "./pages/Clients/ClientsNew"
import Mailings from "./pages/Mailings/Mailings"
import Subscribe from "./pages/Subscribs/Subscribe"
import Versions from "./pages/Versions/Versions"
import Params from "./pages/Params/Params"
import Passages from "./pages/Administrator/Passages/Passages"
import TrainingRecords from "./pages/Administrator/TrainingRecords/TrainingRecords"
import ClubDocuments from "./pages/Documents/ClubDocuments/ClubDocuments"
import PersonalTrainings from "./pages/Administrator/PersonalTrainings/PersonalTrainings"
import TrainSched from "./pages/Administrator/TrainSched/TrainSched"
import PaymentsToCoaches from "./pages/Administrator/PaymentsToCoaches/PaymentsToCoaches"
import PacketsServices from "./pages/Administrator/PacketsServices/PacketsServices"
import Certificates from "./pages/Administrator/Certificates/Certificates"
import PaymentReminders from "./pages/Subscribs/PaymentReminders/paymentReminders"
import Rating from "./pages/UsersRating/Rating/Rating"
import AccuralPointsRules from "./pages/UsersRating/AccuralPointsRules/AccuralPointsRules"
import Races from "./pages/UsersRating/Races/Races"
import RacesParticipants from "./pages/UsersRating/Races/RacesParticipants"

const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/clients", name: "Клиенты", element: ClientsNew, mnemo: "clients" },
  {
    path: "/abonements",
    name: "Абонементы",
    element: Abonements,
    mnemo: "abonements",
  },
  {
    path: "/admin/certificates",
    name: "Сертификаты",
    element: Certificates,
    mnemo: "certificateTable",
  },
  {
    path: "/admin/trainers",
    name: "Тренеры",
    element: Trainers,
    mnemo: "employs",
  },
  { path: "/admin/clubs", name: "Клубы", element: Clubs, mnemo: "clubs" },
  {
    path: "/admin/clubTypes",
    name: "Типы клубов",
    element: ClubTypes,
    mnemo: "clubTypes",
  },
  {
    path: "/admin/passages",
    name: "Проходы",
    element: Passages,
    mnemo: "passages",
  },
  {
    path: "/admin/payments",
    name: "Оплаты",
    element: Payments,
    mnemo: "payments",
  },
  {
    path: "/admin/bookings",
    name: "Контроль бронирований",
    element: Booking,
    mnemo: "booking",
  },
  { path: "/admin/stocks", name: "Акции", element: Stocks, mnemo: "stocks" },
  {
    path: "/admin/services",
    name: "Услуги",
    element: Services,
    mnemo: "services",
  },
  {
    path: "/admin/slots",
    name: "Временные слоты",
    element: Slots,
    mnemo: "slots",
  },
  {
    path: "/admin/schedule",
    name: "Расписание",
    element: Schedule,
    mnemo: "schedules",
  },
  { path: "/admin/gyms", name: "Залы", element: Gyms, mnemo: "classes" },
  {
    path: "/admin/lockers",
    name: "Шкафчики",
    element: Lockers,
    mnemo: "lockers",
  },
  {
    path: "/admin/personalPackets",
    name: "Пакеты тренировок",
    element: PacketsTrainings,
    mnemo: "personalPackets",
  },
  {
    path: "/admin/personalTrainings",
    name: "Персональные тренировки",
    element: PersonalTrainings,
    mnemo: "personalTrainingsTable",
  },
  {
    path: "/admin/employWorktimes",
    name: "Расписание тренеров",
    element: TrainSched,
    mnemo: "employWorktimesTable",
  },
  {
    path: "/admin/trainings",
    name: "Типы тренировок",
    element: Trainings,
    mnemo: "trainingTypes",
  },
  { path: "/admin/galery", name: "Галерея", element: Galery, mnemo: "gallery" },
  {
    path: "/admin/trainingRecords",
    name: "Записи",
    element: TrainingRecords,
    mnemo: "records",
  },
  {
    path: "/admin/paymentsToTrainers",
    name: "Оплата тренерам",
    element: PaymentsToCoaches,
    mnemo: "trainersPaymentTable",
  },
  {
    path: "/admin/packetsServices",
    name: "Пакеты услуг",
    element: PacketsServices,
    mnemo: "trainingsPackets",
  },
  {
    path: "/account/users",
    name: "Пользователи",
    element: Users,
    mnemo: "users",
  },
  {
    path: "/account/permissions",
    name: "Роли",
    element: Roles,
    mnemo: "roles",
  },
  {
    path: "/mailings",
    name: "Рассылки",
    element: Mailings,
    mnemo: "abonements",
  },
  {
    path: "/subscribes/cancelSubscribes",
    name: "Подписки",
    element: Subscribe,
    mnemo: "cancelRecurrent",
  },
  {
    path: "/subscribes/paymentReminders",
    name: "Уведомления об оплате",
    element: PaymentReminders,
    mnemo: "paymentReminder",
  },
  { path: "/versions", name: "Версии", element: Versions, mnemo: "versions" },
  { path: "/params", name: "Параметры", element: Params, mnemo: "params" },
  {
    path: "/documents/clubs",
    name: "Клубы",
    element: ClubDocuments,
    mnemo: "clubDocuments",
  },
  {
    path: "/usersRating/rating",
    name: "Рейтинг",
    element: Rating,
    mnemo: "rating"
  },
  {
    path: "/usersRating/accuralPointsRules",
    name: "Правила начисления бонусов",
    element: AccuralPointsRules,
    mnemo: "accuralPointsRules"
  },
  {
    path: "/usersRating/races",
    name: "Гонки",
    element: Races,
    mnemo: "races"
  },
]

export default routes
